import { render, staticRenderFns } from "./NewItemSds.vue?vue&type=template&id=7f58d038&scoped=true&"
import script from "./NewItemSds.vue?vue&type=script&lang=js&"
export * from "./NewItemSds.vue?vue&type=script&lang=js&"
import style0 from "./NewItemSds.vue?vue&type=style&index=0&id=7f58d038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f58d038",
  null
  
)

export default component.exports